module.exports = __webpack_public_path__ + "23adc07a21e27f8562b3bb3aa22f8fa0.MP3";